<template>
  <vetster-slide-over ref="aboutSlideOver">
    <template #header>
      <vetster-slide-over-common-heading
        :header="$t('app.about')"
        :show-close="false"
        show-back
        @back="back"
      />
    </template>

    <template #content>
      <p class="py-4 px-standard text-sm text-neutral-700">
        {{ description }}
      </p>
    </template>
  </vetster-slide-over>
</template>

<script>
import VetsterSlideOver from '@/brand-components/VetsterSlideOver';
import VetsterSlideOverCommonHeading from '@/brand-components/VetsterSlideOverCommonHeading';

export default {
  name: 'VetsterPartnerAbout',

  components: {
    VetsterSlideOver,
    VetsterSlideOverCommonHeading,
  },

  props: {
    description: {
      type: String,
      required: true,
    },
  },

  methods: {
    open() {
      this.$refs.aboutSlideOver.open();
    },
    back() {
      this.$refs.aboutSlideOver.close();
    },
  },
};
</script>
